export const Successes: { [key: string] : any }  = {
    bg: {
        successTitle: "Успешна операция",
        errorTitle: "Възникна грешка",
        infoTitle: "Съобщение",
        createUser: 'Създадохте своя профил успешно!',
        loginUser: 'Влязохте в своя профил успешно!',
        resetPasswordEmail: 'Имейл за смяна на паролата беше изпратен успешно!',
        changedPassword: 'Вашата парола бе сменена успешно!',
        deletedUser: 'Вие изтрихте вашия профил успешно!',
        updateUser: 'Успешно обновихте профила си!',
        addedToCart: 'Успешно добавихте продукта в количката!',
        addressAdded: 'Успешно добавихте вашия адрес!',
        favourite: 'Добавихте продукта в любими!',
        unfavourite: 'Премахнахте продукта от любими!',
        addToCart: 'Продуктът е добавен',
        addCard: "Успешно добавихте своята карта!",
        addContact: "Успешно добавихте своя адрес!",
        updateContact: "Успешно обновихте своя адрес!",
        removeCard: "Успешно премахнахте своята карта!",
        removeContact: "Успешно премахнахте своя адрес!",
        reviewUpload: "Успешно добавихте своето ревю!"

    }
}